var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({on:{"focusout":_vm.onFocusOutHandler},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }